import { useEffect } from 'react'
import './ItemGraphic.css'

function ItemGraphic(props) {

    useEffect(() => {
        const paintSeason = () => {
            let dates = props.singleItem.date
            if (dates === undefined) dates = []
            dates.map(item => {
                let element = document.getElementById("month" + item)
                return element.classList.add("itIsSeason")
            })
        }
        paintSeason()
    }, [props.singleItem])

    return (
        <div className="graphic">
            <p>{props.singleItem.europe_only ? "Europeisk säsong:" : "Svensk säsong:" }</p>
            <div className="seasonGraphic" id="season">
                <div id="month0">J</div>
                <div id="month1">F</div>
                <div id="month2">M</div>
                <div id="month3">A</div>
                <div id="month4">M</div>
                <div id="month5">J</div>
                <div id="month6">J</div>
                <div id="month7">A</div>
                <div id="month8">S</div>
                <div id="month9">O</div>
                <div id="month10">N</div>
                <div id="month11">D</div>
            </div>
        </div>
    )
}

export default ItemGraphic